function importAll(r) {
  Array.from(r.keys()).forEach(r);
}

importAll(require.context('../components', true, /_component\.js$/));


